module.exports = new __parcel__URL__("dark.438a23d7.svg").toString();